import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateArticle, getArticleById, getMagzineAndDairy } from './_request';
import { useAuth } from '../context/AuthContext';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const EditArticle = () => {

  const navigate = useNavigate();
  const { authToken } = useAuth();
  const location = useLocation();  
  const { articleId } = location.state; 
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [readTime, setReadTime] = useState('');
  const [category, setCategory] = useState('');
  const [parentCategory, setParentCategory] = useState('');
  const [error, setError] = useState('');
  const [articleType, setArticleType] = useState('');
  const [magzine, setMagzine] = useState([]); 
  const [diary, setDiary] = useState([]); 
  const [year, setYear] = useState(''); 
  const [loading, setLoading] = useState(false);
 useEffect(() => {
  const magzineAndDiary = async () => {
    try {
      const response = await getMagzineAndDairy(authToken);
      if (response.Result) {
        setMagzine(response.Magazines);
        setDiary(response.Diaries);
      }
    } catch (error) {
      console.error('Error fetching magazines and diaries:', error);
    }
  };

 
    const fetchArticle = async () => {
      try {
        const article = await getArticleById(authToken, articleId);
        if(article.Result){
          const data = article.Article
        setTitle(data.title);
        setContent(data.content);
        setReadTime(data.read_min);
        setParentCategory(data.parentCategory || '');
        setCategory(data.category);
        setArticleType(data.article_type);
        setYear(data.year)
        }
      } catch (err) {
        setError('Failed to fetch article data');
      }
    };
    fetchArticle();
    magzineAndDiary()
  }, [articleId, authToken]);

  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleContentChange = (value) => setContent(value);
  const handleReadTimeChange = (e) => setReadTime(e.target.value);
  const handleCategoryChange = (e) => setCategory(e.target.value);
  const handleArticleTypeChange = (e) => setArticleType(e.target.value);
  const handleYearChange = (e) => setYear(e.target.value);

  const handleSubmit = async () => {
    if (!title || !content || !category || !articleType || !year) {
      setError('Please fill out all fields');
      return;
    }
    setError('');
    const data = { title, content, readTime, category, articleType, parentCategory, year };
    try {
      setLoading(true);
      const response = await updateArticle(authToken, articleId, data);
      if (response.Result) {
        alert('Article updated successfully!');
        navigate('/tazakuraat');
      } else {
        setError('Failed to update the article. Please try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
      console.error('Error updating article:', error);
    } finally {
      setLoading(false);
    }
  };
  const modules = {
    toolbar: [
      [{ header: 1 }, { header: 2 }, { header: 3 }, { header: 4 }, { font: [] }], // Custom headers
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['clean'],
    ],
  };
  
  const formats = [
    'header', 'font', 'size', 'bold', 'italic', 'underline',
    'color', 'background', 'list', 'bullet', 'align'
  ];
  return (
    <div className="sm:px-6 lg:px-8">
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/tazakuraat')}
        disabled={loading}
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : 'Go Back'}
      </Button>
      <div className="w-full h-fit bg-white p-6 rounded-lg shadow-lg">
        {/* Page Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold">Edit Article</h2>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : 'Update Article'}
          </Button>
        </div>

        {/* Article Form */}
        <div>
          {error && (
            <div className="text-red-500 text-sm mb-4">{error}</div>
          )}
          {/* Title Input */}
          <div className="mb-6">
            <label htmlFor="title" className="block text-sm font-semibold mb-2">
              Title
            </label>
            <input
              type="text"
              id="title"
              value={title}
              onChange={handleTitleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              placeholder="Enter article title"
            />
          </div>
          {/* Article Type Select */}
          <div className="mb-6">
            <label htmlFor="articleType" className="block text-sm font-semibold mb-2">
              Article Type
            </label>
            <Select
              value={articleType}
              onChange={handleArticleTypeChange}
              fullWidth
            >
              <MenuItem value="">Select Article Type</MenuItem>
              <MenuItem value="Magazine">Magazine</MenuItem>
              <MenuItem value="Diary">Diary</MenuItem>
            </Select>
          </div>
          {articleType === 'Diary' &&
            <div className="mb-6">
              <label htmlFor="articleType" className="block text-sm font-semibold mb-2">
                Parent Category
              </label>
              <Select
                value={parentCategory}
                onChange={(e) => setParentCategory(e.target.value)}
                fullWidth
              >
                <MenuItem value="">Select Article Type</MenuItem>
                <MenuItem value="محاسبہ">محاسبہ</MenuItem>
                <MenuItem value="یاد امام"> یاد امام </MenuItem>
              </Select>
            </div>}
            {articleType && (
            <div className="mb-6">
              <label htmlFor="year" className="block text-sm font-semibold mb-2">
                Year
              </label>
              <Select
                value={year}
                onChange={handleYearChange}
                fullWidth
              >
                <MenuItem value="">Select Year</MenuItem>
                {articleType === "Magazine"
                  ? magzine.map((mag) => (
                      <MenuItem key={mag.id} value={mag.id}>
                        {mag.year}
                      </MenuItem>
                    ))
                  : diary.map((diary) => (
                      <MenuItem key={diary.id} value={diary.id}>
                        {diary.year}
                      </MenuItem>
                    ))}
              </Select>
            </div>
          )}
          {/* Category Input */}
          <div className="mb-6">
            <label htmlFor="category" className="block text-sm font-semibold mb-2">
              Category
            </label>
            <Select
              name="category"
              value={category}
              onChange={handleCategoryChange}
              fullWidth

            >
              <MenuItem value="" disabled>Select Category</MenuItem>
              {articleType === "Diary"
                ? parentCategory === "محاسبہ"
                  ? [
                    { value: "محاسبہ", label: "محاسبہ" },                    
                    { value: "نماز شب", label: "نماز شب" },
                    { value: "نماز صبح و سحر خیزی", label: "نماز صبح و سحر خیزی" },
                    { value: "قرآن و دعا", label: "قرآن و دعا" },
                    { value: "ورزش", label: "ورزش" },
                    { value: "نظم ٹائم ٹیبل", label: "نظم ٹائم ٹیبل" },
                    { value: "غور و فکر", label: "غور و فکر" },
                    { value: "مطالعہ و حصول علم", label: "مطالعہ و حصول علم" },
                    { value: "تعلیم اہل خانہ و مومنین", label: "تعلیم اہل خانہ و مومنین" },
                    { value: "صدقہ", label: "صدقہ" },
                    { value: "معرفت امام زمانہ علیہ السلام", label: "معرفت امام زمانہ علیہ السلام" },
                    { value: "تعارف امام میں سعی", label: "تعارف امام میں سعی" },
                    { value: "احسان به والدین صله رحم", label: "احسان به والدین صله رحم" },
                    { value: "امداد مؤمنین", label: "امداد مؤمنین" },
                    { value: "ایفائے عہد", label: "ایفائے عہد" },
                    { value: "امر معروف و نهی از منکر", label: "امر معروف و نهی از منکر" },
                    { value: "مستحب روزه", label: "مستحب روزه" },
                    { value: "نامحرم پر نگاہ سے اجتناب", label: "نامحرم پر نگاہ سے اجتناب" },
                    { value: "غیبت و تہمت سے دوری", label: "غیبت و تہمت سے دوری" },
                    { value: "جھوٹ ونفاق سے پر ہیز", label: "جھوٹ ونفاق سے پر ہیز" },
                    { value: "بد اخلاقی پخش گوئی سے اجتناب", label: "بد اخلاقی پخش گوئی سے اجتناب" },
                    { value: "لہو ولعب سے پر ہیز غضب و غصہ سے دوری", label: "لہو ولعب سے پر ہیز غضب و غصہ سے دوری" },
                    { value: "ریا کاری سے اجتناب", label: "ریا کاری سے اجتناب" },
                    { value: "حد سے پر ہیز", label: "حد سے پر ہیز" },
                  ].map((cat) => (
                    <MenuItem key={cat.value} value={cat.value}>
                      {cat.label}
                    </MenuItem>
                  ))
                  : <MenuItem value="یاد امام">یاد امام</MenuItem>
                : articleType === "Magazine"
                  ? [
                    { value: "محرم", label: "محرم" },
                    { value: "ایام فاطمیہ", label: "ایام فاطمیہ" },
                  ].map((cat) => (
                    <MenuItem key={cat.value} value={cat.value}>
                      {cat.label}
                    </MenuItem>
                  ))
                  : null}
            </Select>
          </div>

          {/* Read Time Input */}
          <div className="mb-6">
            <label htmlFor="readTime" className="block text-sm font-semibold mb-2">
              Read Time (minutes)
            </label>
            <input
              type="number"
              id="readTime"
              value={readTime}
              onChange={handleReadTimeChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              placeholder="Enter article read time"
            />
          </div>
          {/* Quill Editor */}
          <div className="border-none">
            <label htmlFor="content" className="block text-sm font-semibold mb-2">
              Content
            </label>
            <div className='mb-14'>
              <ReactQuill
                value={content}
                onChange={handleContentChange}
                modules={modules}
                formats={formats}
                className="h-52"
                placeholder="Write your article content here"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditArticle;